import { render, staticRenderFns } from "./FarmStatisticsPanel.vue?vue&type=template&id=1525d686&scoped=true&"
import script from "./FarmStatisticsPanel.vue?vue&type=script&lang=js&"
export * from "./FarmStatisticsPanel.vue?vue&type=script&lang=js&"
import style0 from "./FarmStatisticsPanel.vue?vue&type=style&index=0&id=1525d686&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1525d686",
  null
  
)

export default component.exports